import { simpleSet } from '@r/reducers/utils';
import { _ISimpleSet, AllActions } from '@r/storeUtils';

const s = simpleSet as _ISimpleSet<
  redux._IConstants['SET_UNITS'],
  redux._IStore['projectFor3d']['units'],
  AllActions
>;
export const units = s( 'SET_UNITS', 'inch' );
